import script from "./FrequencyChangeAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequencyChangeAudit.vue?vue&type=script&setup=true&lang=js"

import "./FrequencyChangeAudit.vue?vue&type=style&index=0&id=ec81721e&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec81721e"]])

export default __exports__